import React from 'react';
import './label.scss';

export const Label = React.forwardRef(({
    className = '',
    children,
    ...props
}, ref) => {
    return (
        <label
            ref={ref}
            className={`label ${className}`}
            {...props}
        >
            {children}
        </label>
    );
});

Label.displayName = 'Label';
